import { Address, Provider, WeiPerEther, getContract } from 'nftx.js';
import UniswapV2Pair from '@/domain/migrate/abis/UniswapV2Pair';
import { isAddressWeth } from '@/domain/ticks/helpers';

const fetchV2PositionReserves = async ({
  balance,
  network,
  provider,
}: {
  provider: Provider;
  balance: { address: Address; balance: bigint };
  network: number;
}) => {
  // To work out the value of the position,
  // we need to get the total supply of the LP token
  // then work out the user's share of the pool
  // Then we get the reserves (work out which is vToken and which is weth)
  // And then work out the user's share of the reserves
  // In v2 you can roughly work out the value of the position by
  // multiplying the user's share of the reserves by 2
  const contract = getContract({
    provider,
    address: balance.address,
    abi: UniswapV2Pair,
  });
  const totalSupply = await contract.read.totalSupply({});
  const share = (balance.balance * WeiPerEther) / totalSupply;
  const token0 = await contract.read.token0({});
  const isToken0Weth = isAddressWeth(token0, network);
  const [reserve0, reserve1] = await contract.read.getReserves({});
  const token0Share = (reserve0 * share) / WeiPerEther;
  const token1Share = (reserve1 * share) / WeiPerEther;
  const vToken = isToken0Weth ? token1Share : token0Share;
  const eth = isToken0Weth ? token0Share : token1Share;
  const value = eth * 2n;

  return { vToken, eth, value };
};

export default fetchV2PositionReserves;
